<template>
  <section class="browse-search" v-bind:class="className">
    <div v-if="mode === 'default' || mode === 'browse'" class="browse-search__section browse-search__browse-form">
      <BrowseForm
        :mode="mode"
        :nbResults="nbResults"
        :routeName="routeName"
        :industry="industry"
        :industryOptions="industryOptions"
        :sector="sector"
        :sectorOptions="sectorOptions"
        :category="category"
        :categoryOptions="categoryOptions"
        :industryLoading="industryLoading"
        :sectorLoading="sectorLoading"
        :categoryLoading="categoryLoading"
        :submit="browseSubmit"
        :industryChange="updateIndustry"
        :sectorChange="updateSector"
        :categoryChange="updateCategory"
      />
    </div>
        
    <div v-if="mode === 'default'" class="browse-search__section browse-search__separator"><h3>Or</h3></div>
        
    <div v-if="mode === 'default' || mode === 'search'" class="browse-search__section browse-search__search-form">
      <SearchForm 
        :mode="mode"
        :term="term"
        :nbResults="nbResults"
        :submit="searchSubmit"
        :helpForSearchTerm="helpForSearchTerm"
      />
    </div>
  </section>
</template>

<script>
  import Vue from 'vue';
  import SearchForm from './SearchForm.vue';
  import BrowseForm from './BrowseForm.vue';

  export default Vue.component('MainForm', {
    props: {
      term: String,
      mode: String,
      routeName: String,
      nbResults: Number,
      helpForSearchTerm: String,
      industry: String,
      industryOptions: Array,
      sector: String,
      sectorOptions: Array,
      category: String,
      categoryOptions: Array,
      industryLoading: Boolean,
      sectorLoading: Boolean,
      categoryLoading: Boolean,
      searchSubmit: Function,
      updateIndustry: Function,
      updateSector: Function,
      updateCategory: Function,
      browseSubmit: Function,
    },
    computed: {
      className: function() {
        return `browse-search--${this.mode}`;
      }
    }
  });
</script>